import React,{Component} from 'react';
import ReactPaginate from 'react-paginate';

import './style.css';



let times = 10;

class Pager extends Component {
    constructor(props) {
        super(props);
        //console.log("constructor props", props);
        this.state = {
            ...props
        }
    }
    componentWillReceiveProps(props){
        this.setState({
            ...this.state,
            props
        })
    }
    componentDidUpdate(prevProps) {
        if (prevProps.pager != this.props.pager) {
            //console.log("pager поменялся", this.props);
            let { pager } = this.props;
            let pagesCount = (Math.ceil(pager.total / pager.count));

            pagesCount = pagesCount > 0 ? pagesCount : 1;
            if (pager.page > pagesCount) {
                //console.log("pager.page > pagesCount", { "pager.page": pager.page, pagesCount: pagesCount });
                pager.page = pagesCount;


                if (times > 0) {
                    times--;
                    this.throwPageChange(pager);
                }

            }
        }
    }
    handlePageClick = (data) => {
        let pager = this.props.pager;
        pager.page = data.selected + 1;
        this.throwPageChange(pager);


    }
    throwPageChange(pager) {
        if (this.props.onPageChange) {
            this.props.onPageChange(pager);
        }
    }
    render() {
        let pager = this.props.pager;
        let pageCount = Math.ceil(pager.total / pager.count);
        return (
            <div className="react-paginate">
                <ReactPaginate previousLabel="←"
                               nextLabel="→"
                               breakLabel={"..."}
                               breakClassName={"break-me"}
                               pageCount={pageCount}
                               marginPagesDisplayed={2}
                               pageRangeDisplayed={2}
                               onPageChange={this.handlePageClick.bind(this)}
                               containerClassName={"r-pagination"}
                               subContainerClassName={"pages r-pagination"}
                               activeClassName={"active"}
                               initialPage={pager.page - 1}
                               forcePage={pager.page - 1}
                               disableInitialCallback = {true}
                />
            </div>
        );
    }
}

export default Pager;


// WEBPACK FOOTER //
// ./src/components/Shared/Pager/index.jsx